import { render, staticRenderFns } from "./DocumentTemplateFilter.vue?vue&type=template&id=2d068845&scoped=true&"
import script from "./DocumentTemplateFilter.vue?vue&type=script&lang=ts&"
export * from "./DocumentTemplateFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d068845",
  null
  
)

export default component.exports